import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { LinkedinLoginView } from './components/LinkedinAccount';

/** LinkedIn connection of the sourcing, opened in its own browser tab from the Sourcing page. */
const LinkedinLoginPage = () => {
  // Opened by the Sourcing page: the tab closes itself once the account is connected.
  const onConnected = useCallback(() => {
    setTimeout(() => window.close(), 2500);
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%', bgcolor: '#f5f7fa' }}>
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e2e8f0', px: { xs: 2, md: 3 }, py: 1.5, display: 'flex', alignItems: 'center', gap: 1.25 }}>
        <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: '#e8f1fb', color: '#0a66c2', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <LinkedInIcon />
        </Box>
        <Box>
          <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Connexion à LinkedIn</Typography>
          <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>Connectez-vous comme d'habitude : cet onglet se ferme tout seul une fois connecté.</Typography>
        </Box>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: { xs: 1.5, md: 3 } }}>
        <Box sx={{ maxWidth: 1040, mx: 'auto', bgcolor: '#fff', border: '1px solid #e2e8f0', borderRadius: '14px', p: { xs: 1.5, md: 2.5 } }}>
          <LinkedinLoginView onConnected={onConnected} />
        </Box>
      </Box>
    </Box>
  );
};

export default LinkedinLoginPage;
